import { createSlice } from '@reduxjs/toolkit';

import { UserStatus } from '../../constants/UserManagementConstants';

import { IUser } from '../../../features/Settings/UserManagement/api/type-def';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IUsersMgmtState {
	allUsersList: IUser[];
	usersList: IUser[];
	isCalendar: boolean;
	selectedTab: number;
	activeUsers: IUser[];
	inActiveusers: IUser[];
}

const initialState: IUsersMgmtState = {
	allUsersList: [],
	usersList: [],
	isCalendar: false,
	selectedTab: 0,
	activeUsers: [],
	inActiveusers: [],
};

const { ACTIVE, INACTIVE } = UserStatus;

export const userMgmtSlice = createSlice({
	name: 'usersListmgmt',
	initialState,
	reducers: {
		setAllUsersList: (state, action: PayloadAction<IUser[]>) => {
			state.allUsersList = action.payload;
			state.usersList = action.payload;
			const activeListUsers = state.usersList.filter(
				(ele: IUser) => ele?.status === ACTIVE,
			);
			state.activeUsers = activeListUsers;
			const inactiveListUsers = state.usersList.filter(
				(ele: IUser) => ele?.status === INACTIVE,
			);
			state.inActiveusers = inactiveListUsers;
		},

		setCalendarDialog: (state, action: PayloadAction<boolean>) => {
			state.isCalendar = action?.payload;
		},
		setSelectedTab: (state, action: PayloadAction<number>) => {
			state.selectedTab = action?.payload;
		},
		setUsersList: (state, action: PayloadAction<IUser[]>) => {
			state.usersList = action?.payload;
			const activeListUsers = state.usersList.filter(
				(ele: IUser) => ele?.status === ACTIVE,
			);
			state.activeUsers = activeListUsers;
			const inactiveListUsers = state.usersList.filter(
				(ele: IUser) => ele?.status === INACTIVE,
			);
			state.inActiveusers = inactiveListUsers;
		},

		setActiveUsers: (state, action: PayloadAction<IUser[]>) => {
			const tempusers = action?.payload;
			const activeUsers = tempusers.filter(
				(ele: IUser) => ele?.status === ACTIVE,
			);
			state.usersList = activeUsers;
		},

		setInActiveUsers: (state, action: PayloadAction<IUser[]>) => {
			const tempusers = action?.payload;
			const inactiveUsers = tempusers.filter(
				(ele: IUser) => ele?.status === INACTIVE,
			);
			state.usersList = inactiveUsers;
		},

		setSearchUsers: (state, action: PayloadAction<IUser[]>) => {
			state.usersList = action?.payload;
		},
	},
});

export const {
	setAllUsersList,
	setUsersList,
	setCalendarDialog,
	setSelectedTab,
	setSearchUsers,
	setInActiveUsers,
	setActiveUsers,
} = userMgmtSlice.actions;
export default userMgmtSlice.reducer;
